import * as React from "react";
const SVGComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={21}
    height={26}
    viewBox="0 0 21 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.24172 13.4883C7.00492 13.2777 6.66277 13.2777 6.4522 13.5145L4.08369 16.0409C3.87314 16.2515 3.87314 16.5936 4.08369 16.804L6.42579 19.3566C6.53097 19.4882 6.68902 19.5409 6.84688 19.5409C6.9785 19.5409 7.13637 19.4882 7.24154 19.383C7.47834 19.1725 7.47834 18.8041 7.26779 18.5673L5.26785 16.4093L7.26779 14.2513C7.50477 14.0672 7.47852 13.6988 7.24173 13.4883L7.24172 13.4883Z"
      fill={color}
    />
    <path
      d="M14.0838 13.5145C13.8733 13.2777 13.5049 13.2777 13.2943 13.4883C13.0575 13.6988 13.0575 14.0672 13.2681 14.304L15.268 16.462L13.2681 18.62C13.0575 18.8568 13.0575 19.1989 13.2943 19.4357C13.3995 19.5409 13.5311 19.5936 13.689 19.5936C13.8468 19.5936 14.0047 19.5409 14.1101 19.4093L16.4522 16.8567C16.6627 16.6461 16.6627 16.3039 16.4522 16.0936L14.0838 13.5145Z"
      fill={color}
    />
    <path
      d="M11.0587 12.4625C10.743 12.4099 10.4535 12.5942 10.4008 12.9099L9.03237 20.0678C8.97969 20.3835 9.16399 20.673 9.47972 20.7256H9.5849C9.84813 20.7256 10.0849 20.5414 10.1376 20.2521L11.5061 13.0942C11.5588 12.831 11.3745 12.5152 11.0587 12.4626L11.0587 12.4625Z"
      fill={color}
    />
    <path
      d="M19.6906 6.72538L13.9275 0.962246C13.5591 0.593836 13.0591 0.383301 12.559 0.383301H2.21694C1.69067 0.383301 1.2169 0.59385 0.848477 0.962246C0.480067 1.33066 0.269531 1.80425 0.269531 2.33071V23.4359C0.269531 24.5149 1.13795 25.3833 2.21694 25.3833H18.3221C19.4011 25.3833 20.2696 24.5149 20.2696 23.4359V8.09384C20.2696 7.59399 20.059 7.09399 19.6906 6.72557V6.72538ZM18.5853 7.19897H14.3221C13.8485 7.19897 13.4536 6.80431 13.4536 6.33055L13.4538 2.09373L18.5853 7.19897ZM18.3221 24.2515H2.21691C1.76957 24.2515 1.40117 23.8831 1.40117 23.4358V2.33061C1.40117 2.12007 1.4801 1.90952 1.63797 1.75167C1.79584 1.5938 2.00638 1.51487 2.21692 1.51487H12.3221V6.33064C12.3221 7.4359 13.2168 8.33059 14.3221 8.33059H19.1379V23.4358C19.1379 23.883 18.7694 24.2515 18.3221 24.2515L18.3221 24.2515Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
